import { syllabiLoader } from "./syllabiLoader.ts";

const basePath = "/:prefix/faculty-products/:vbid";

export const facultyProductRoutes = {
  path: basePath,
  async lazy() {
    const { Component, loader, ErrorBoundary } = await import("./lazyRoute");
    return { Component, loader, ErrorBoundary };
  },
  children: [
    {
      path: "syllabi",
      loader: syllabiLoader,
    },
    {
      path: "request-access",
      async lazy() {
        const { requestVerification } = await import("./lazyRoute");
        return { action: requestVerification };
      },
    },
    {
      path: "add-to-library",
      async lazy() {
        const { addToLibrary } = await import("./lazyRoute");
        return { action: addToLibrary };
      },
    },
    {
      path: "renew-sample",
      async lazy() {
        const { renewSample } = await import("./lazyRoute");
        return { action: renewSample };
      },
    },
  ],
};
